import { ClientType } from '@common/model/client/clientType';
import { clientTypeToSuitableCatalogItemType } from '@common/utils/catalogType';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { useClientProfile } from 'src/entities/client';
import { useConnectWithCatalogItemAuthor } from 'src/features/catalogItem/connect';
import { mapCatalogItemToClientSelection, useAuthInterceptor } from 'src/features/auth';

export const useConnectAction = (catalogItem: CatalogItemViewModel | undefined): [() => void, { isAvailable: boolean }] => {
  const clientProfile = useClientProfile();
  const connect = useConnectWithCatalogItemAuthor();
  const withAuth = useAuthInterceptor();
  const isAvailable =
    !clientProfile || (catalogItem ? clientTypeToSuitableCatalogItemType(clientProfile.type as ClientType) === catalogItem.type : false);

  const fn = () => {
    if (catalogItem) {
      return withAuth(connect, mapCatalogItemToClientSelection(catalogItem))(catalogItem.id);
    }
  };

  return [fn, { isAvailable }];
};
